import { useEffect, useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

const FiscalYearDropdown = ({
  fiscalYears,
  selectedFiscalYearId,
  onFiscalYearDropDownChange,
}) => {
  const [sortedFiscalYears, setSortedFiscalYears] = useState([])

  useEffect(() => {
    const sorted = Array.isArray(fiscalYears)
      ? [...fiscalYears].sort((a, b) => b.id - a.id)
      : []

    setSortedFiscalYears(sorted)
  }, [fiscalYears])

  const handleChange = (event) => {
    onFiscalYearDropDownChange(event.target.value)
  }

  return (
    <FormControl variant="outlined">
      <InputLabel>Exercice</InputLabel>
      <Select
        value={
          selectedFiscalYearId == null ||
          fiscalYears == null ||
          fiscalYears.length == 0
            ? ''
            : Number(selectedFiscalYearId)
        }
        onChange={handleChange}
        label="Exercice"
        size="small"
      >
        {selectedFiscalYearId == null ||
        fiscalYears == null ||
        fiscalYears.length == 0
          ? null
          : sortedFiscalYears.map((fiscalYear) => (
              <MenuItem key={fiscalYear.id} value={fiscalYear.id}>
                {fiscalYear.name}
              </MenuItem>
            ))}
      </Select>
    </FormControl>
  )
}

export default FiscalYearDropdown
